<template>
  <div class="container">
    <ReservationIsCreated
      :reservation="{ id: $route.params.id }"
    ></ReservationIsCreated>
    <div class="u-text-align-center u-margin-top u-margin-bottom">
      <a target="_blank" href="https://rezzervasyon.com">
        <img src="@/assets/images/Logo.png" alt="" />
      </a>
      <p>{{ $t("appName") }}</p>
    </div>
  </div>
</template>

<script>
import ReservationIsCreated from "@/components/Chat/ReservationIsCreated.vue";
export default {
  components: {
    ReservationIsCreated,
  },
};
</script>

<style></style>
